/**
 * Takes a flat array of field keys and groups them into pairs for two-column
 * table layouts. If the array has an odd length, the last pair has null as
 * its second element so the caller can render an empty cell.
 */
export function pairUp<T> (fields: T[]): [T, T | null][] {
  const pairs: [T, T | null][] = [];
  for (let i = 0; i < fields.length; i += 2) {
    pairs.push([fields[i], fields[i + 1] ?? null]);
  }
  return pairs;
}
